import { Quote, Star } from "lucide-react";

const items = [
  {
    quote:
      "They rebuilt our entire site and ops backend in 9 weeks. We've added more pipeline in one quarter than the previous year.",
    name: "James Holloway",
    role: "CEO, Northwind Studios",
    img: "https://images.unsplash.com/photo-1758534063829-a72058381e21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGxvb2tpbmclMjBhdCUyMGNhbWVyYSUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3Nzk4NDEzOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "It's the only agency we've worked with that truly understood both engineering and marketing. The ROAS speaks for itself — 3.4×.",
    name: "Sophia Reyes",
    role: "Founder, Astra Wellness",
    img: "https://images.unsplash.com/photo-1758600587730-a11917c13b85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGxvb2tpbmclMjBhdCUyMGNhbWVyYSUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3Nzk4NDEzOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "Our internal CRM was a mess. Abdo's team replaced it with a custom system that actually fits how we work. Saved 60+ hours/week.",
    name: "Daniel Mercer",
    role: "MD, Mercer Partners",
    img: "https://images.unsplash.com/photo-1758534063829-a72058381e21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGxvb2tpbmclMjBhdCUyMGNhbWVyYSUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3Nzk4NDEzOHww&ixlib=rb-4.1.0&q=85",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-16 md:py-24 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="reveal flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-6">
          <div>
            <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#00F0FF]">
              / Reviews
            </div>
            <h2 className="mt-4 font-display text-5xl md:text-6xl font-extrabold leading-[0.95] tracking-[-0.03em]">
              Loved by founders
              <br />
              <span className="text-slate-500">who hate fluff.</span>
            </h2>
          </div>
          <div className="flex items-center gap-2 text-sm text-slate-400">
            <div className="flex">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-[#00F0FF] text-[#00F0FF]" />
              ))}
            </div>
            4.9 / 5 average across 40+ engagements
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-7">
          {items.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-card-${i}`}
              className={`reveal relative bg-[#0A0F1C] border border-white/[0.08] rounded-3xl p-8 ${
                i === 1 ? "md:translate-y-8" : ""
              }`}
            >
              <Quote className="h-7 w-7 text-[#007AFF]/60" />
              <blockquote className="mt-5 text-lg leading-relaxed text-slate-200 font-display font-medium">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-3 pt-6 border-t border-white/5">
                <img
                  src={t.img}
                  alt={t.name}
                  className="h-11 w-11 rounded-full object-cover border border-white/10"
                />
                <div>
                  <div className="font-semibold text-white">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
